<template>
  <div class="playlet">
    <el-card>
      <!-- <el-button
        size="mini"
        type="success"
        icon="el-icon-s-help"
        style="float: right;margin-bottom:10px"
        @click="add"
      >创建</el-button> -->
      <div class="cpsselectbox">
        <el-input
          style="width: 300px;"
          v-model="parameter.keyword"
          placeholder="请输入appid/小程序名称"
        ></el-input>
        <el-select
          v-model="parameter.onlyMe"
          placeholder="请选择"
          style="margin-left:20px"
        >
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="名称"
            width="380"
            align="center"
          />
          <el-table-column
            prop="account_name"
            label="小程序名称"
            width="200"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="appId"
            width="200"
            align="center"
          />
          <el-table-column
            prop="jump_page"
            label="链接"
            width="300"
            align="center"
          />
          <el-table-column
            prop="admin_name"
            label="创建人"
            width="150"
            align="center"
          />
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            width="260"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="warning"
                size="small"
                @click="edit(scope.row)"
              >编辑</el-button>
              <el-button
                type="danger"
                size="small"
                @click="myDelete(scope.row.id)"
              >删除</el-button>
              <el-button
                v-clipboard:copy="scope.row.jump_page"
                v-clipboard:success="onCopys"
                v-clipboard:error="onError"
                type="primary"
                size="mini"
              >复制链接</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="链接地址"
      :visible.sync="cookiedialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="700px"
    >
      <linkdialog
        ref="sourdialogview"
        @updata="updatar"
      />
    </el-dialog>
  </div>
</template>

<script>
import linkdialog from './components/linkdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { wxCpspromotionlist, wxCpspromotiondelete } from '@/api/sourceminiprogram.js'
export default {
  name: 'LinkList',
  components: {
    PaginationRight,
    linkdialog
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        keyword: null,
        onlyMe: 2
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内链接'
        },
        {
          value: 2,
          label: '我关联的链接'
        }
      ],
      loading: false,
      tableData: [],
      total: null,
      cookiedialogVisible: false
    }
  },

  created() {
    this.getDatas()
  },
  activated() {
    this.getDatas()
  },
  mounted() {},
  methods: {
    add() {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(1)
      })
    },
    edit(item) {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(2, item)
      })
    },
    async getDatas() {
      this.loading = true
      const data = await wxCpspromotionlist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    // 删除
    myDelete(id) {
      console.log('id', id)
      this.$confirm('此操作将删除链接, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          wxCpspromotiondelete({
            id: id
          }).then(res => {
            this.getDatas()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    searchclick() {
      this.parameter.page = 1
      this.getDatas()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        keyword: null,
        onlyMe: 2
      }
      this.getDatas()
    },

    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    },
    onError() {
      this.$message.error('复制失败')
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
.cpsselectbox {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>

